import { render } from "./ListaView.vue?vue&type=template&id=402d588f"
import script from "./ListaView.vue?vue&type=script&lang=js"
export * from "./ListaView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__